import { HttpResponse as RestResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService, HttpResponse, HttpStatusEnum } from '@core/api';
import { FileExtensionEnum } from '../../_enums';

@Injectable()
export class ResultsDownloadApi {
    private readonly resourceUrl = 'results/download';

    constructor(private apiService: ApiService) {}

    downloadAllOrderResults(orderId: number) {
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService.get(`${this.resourceUrl}/all`, { orderId: orderId }, 'arraybuffer', 'response').subscribe({
                next: res => {
                    downloadFile(res, `order_${orderId}_results`);
                    resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                },
                error: () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }

    downloadPerOrderOrRetestResults(orderOrRetestId: number) {
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService
                .get(`${this.resourceUrl}/per-order`, { orderId: orderOrRetestId }, 'arraybuffer', 'response')
                .subscribe({
                    next: res => {
                        downloadFile(res, `order_${orderOrRetestId}_results`);
                        resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                    },
                    error: () => {
                        resolve({ data: null, status: HttpStatusEnum.ERROR });
                    },
                });
        });
    }

    downloadOneFilePerOrderOrRetestResults(orderOrRetestId: number, fileType: FileExtensionEnum) {
        const extension = fileType === FileExtensionEnum.AB1 ? 'ab1' : 'seq';
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService
                .get(
                    `${this.resourceUrl}/per-order/${extension}`,
                    { orderId: orderOrRetestId },
                    'arraybuffer',
                    'response'
                )
                .subscribe({
                    next: (res: RestResponse<Blob>) => {
                        downloadFile(res, `order_${orderOrRetestId}_results`);
                        resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                    },
                    error: () => {
                        resolve({ data: null, status: HttpStatusEnum.ERROR });
                    },
                });
        });
    }

    downloadSeqReactionResults(reactionId: number) {
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService.get(`${this.resourceUrl}/seq`, { reactionId: reactionId }, 'arraybuffer', 'response').subscribe({
                next: (res: RestResponse<Blob>) => {
                    downloadFile(res, `reaction_${reactionId}_results`);
                    resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                },
                error: () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }

    downloadAb1ReactionResults(reactionId: number) {
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService.get(`${this.resourceUrl}/ab1`, { reactionId: reactionId }, 'arraybuffer', 'response').subscribe({
                next: (res: RestResponse<Blob>) => {
                    downloadFile(res, `reaction_${reactionId}_results`);
                    resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                },
                error: () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }
}

function downloadFile(res: RestResponse<Blob>, defaultName: string) {
    const fileName =
        res.headers
            ?.get('content-disposition')
            ?.split(';')
            .map(h => h.trim())
            .filter(h => h.startsWith('filename='))[0]
            .replace('filename=', '') ?? defaultName;

    if (res.body) {
        const newBlob = new Blob([res.body], { type: res.headers.get('content-type') ?? undefined });
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        link.click();
    }
}
